const { gql } = require('graphql-request')

export const DELETE_GENERATED_REPORT = gql`
  mutation DeleteGeneratedReport($id: ID!) {
    deleteGeneratedReport(id: $id) {
      success
    }
  }
`

const mutations = {
  DELETE_GENERATED_REPORT
}

export default mutations 